import { render, staticRenderFns } from "./VotingPreview.vue?vue&type=template&id=0c26678e&"
import script from "./VotingPreview.vue?vue&type=script&lang=js&"
export * from "./VotingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports